import { ApiPath } from "enums";
import { Get, Post } from "utils";

export const login = async ({ email, password, token }) => {
  const data = { email, password, portalType: "locq" };
  if (token) {
    data.token = token;
  }
  const res = await Post(`${ApiPath.Login}`, data);
  return res.data;
};

export const logout = async () => {
  const res = await Get(`${ApiPath.Logout}`);
  return res.data;
};

export const refresh = async ({ refreshToken }) => {
  const res = await Post(`${ApiPath.Refresh}`, { refreshToken });
  return res.data;
};

export const validateOTPTwoFactorAuth = async ({ email, otp }) => {
  const res = await Post(`${ApiPath.TwoFactorAuth}`, { email, otp });
  return res.data;
};
